import { useEffect, useRef, useState } from "react";
import { plantoesApi } from "../api/plantoesApi";

// Antes de salvar um plantão (registrar, duplicar, editar), consulta os conflitos de
// horário. O aviso nunca bloqueia: com conflito, guarda o que ia ser salvo e espera o
// médico escolher "Registrar mesmo assim" (confirm) ou "Voltar" (dismiss). Se a própria
// consulta falhar, salva direto — um aviso indisponível não pode impedir o cadastro.
// Fechar o modal (que chama dismiss) ou desmontá-lo com a consulta ainda pendente
// descarta o salvamento: quem fechou com X/Esc não espera ver o plantão gravado depois.
export function useConflictGuard() {
  const [conflitos, setConflitos] = useState([]);
  const [pendente, setPendente] = useState(null);
  const [isChecking, setIsChecking] = useState(false);
  // Muda a cada dismiss/desmontagem; uma consulta que volta com outro valor foi abandonada.
  const geracao = useRef(0);

  useEffect(
    () => () => {
      geracao.current += 1;
    },
    []
  );

  const guard = async (consulta, salvar) => {
    const minha = geracao.current;
    setIsChecking(true);
    let encontrados = [];
    try {
      encontrados = (await plantoesApi.checkConflicts(consulta)) ?? [];
    } catch {
      encontrados = [];
    } finally {
      setIsChecking(false);
    }
    if (minha !== geracao.current) return;
    if (encontrados.length > 0) {
      setConflitos(encontrados);
      setPendente(() => salvar);
      return;
    }
    salvar();
  };

  const dismiss = () => {
    geracao.current += 1;
    setConflitos([]);
    setPendente(null);
  };

  const confirm = () => {
    const salvar = pendente;
    dismiss();
    if (salvar) salvar();
  };

  return { conflitos, hasConflicts: conflitos.length > 0, isChecking, guard, confirm, dismiss };
}
